import { useCallback } from "react";

import { MessageKey, useT } from "@/i18n";
import { NavLinkItemType } from "@/layouts/DashboardLayout/NavLink/NavLink.types";

const NAV_LINK_SUBTITLES: { [key in NavLinkItemType]?: MessageKey } = {
  managementTeam: "general.navigation.links.subtitle.managementTeam",
};

export const useGetNavLinkSubtitle = () => {
  const t = useT();

  const getNavLinkSubtitle = useCallback(
    (type: NavLinkItemType) => {
      const subtitleKey = NAV_LINK_SUBTITLES[type];
      if (!subtitleKey) return null;
      return t(subtitleKey);
    },
    [t]
  );

  return getNavLinkSubtitle;
};
